
$("ul#MobileNav li.lvl1.parent.megamenu .custom_class_s").click(function(e){
e.preventDefault();
    e.stopPropagation();
    $(this).parents('li').find('.custom_class_s').next().slideToggle();
    $(this).parents('li').find('.custom_class_s i').toggleClass('at-plus-l');
        $(this).parents('li').find('.custom_class_s i').toggleClass('at-minus-l');

});
$("ul#MobileNav li.lvl1.parent.megamenu .custom_class_s i").click(function(e){
e.preventDefault();
    e.stopPropagation();
    

});
 setTimeout(function() {
//  $(".pointer-label.high").text('€79,500');
// $(".scale.fl.f-jcsb span").eq(1).find('ins').text('79,500');
                       $('body').addClass('reviews_loaded_cc');
                    }, 3500);
$("a.actFilter.js-facet-remove").click(function(){
window.location.reload();
});

  

var get_width = $(window).width();
if(get_width > 768){
    $(document).on("click",".loox-rating-content",function() {

    $("ul.fl.f-wrap.product-tabs li").removeClass('active');
$("a.tablink.tc[href='#ptabReview']").parent().addClass('active');
    $(".tab-content").hide();
    $("div#ptabReview").show();
     $('html, body').animate({
        scrollTop: $("ul.fl.f-wrap.product-tabs").offset().top-50
    }, 500);
});
}else{
$(document).on("click",".loox-rating-content",function() {
$("a.tablink.tc[href='#ptabDesc']").trigger('click');
$("div#ptabReview").show();
$("h3.acor-ttl.hide-md.hide-lg").removeClass('active');
$(".tab-container.mb30.noTabs a.tablink.tc[href='#ptabReview']").parent().addClass('active');
     $('html, body').animate({
        scrollTop: $(".tab-container.mb30.noTabs").offset().top+200
    }, 500);
});
}
$(document).ready(function() {
$(".widget-title").trigger('click');

    $(document).on("click",".cart-options-ttl",function() {

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this)
        .siblings(".text-area")
        .slideUp(200);
         $(this)
        .siblings(".card_option_suctom")
        .slideUp(200);
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
    } else {
      $(".set > a i")
        .removeClass("fa-minus")
        .addClass("fa-plus");
      $(this)
        .find("i")
        .removeClass("fa-plus")
        .addClass("fa-minus");
      $(".set > a").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this)
        .siblings(".text-area")
        .slideDown(200);
          $(this)
        .siblings(".card_option_suctom")
        .slideDown(200);
    }
  });
});
$(".swatch-element input").change(function(){
var get_selected = $(".pr_variants.no-js option:selected").attr('data-price');
    $(".var_price_custom").html(get_selected);
});
$(document).ready(function(){
$("div#ptabReview").show();
//$(".cart-options-ttl").trigger('click');
});
